import React from 'react';
import HTMLComponent from './HTMLComponent';
import { t, props } from 'tcomb-react';

@props({
  html: t.Str,
  children: t.Any
})
export default class PurchasePaymentGateway extends React.Component {

  render() {
    return (
      <div>
        <HTMLComponent>{this.props.html}</HTMLComponent>
        <div>
          {this.props.children}
        </div>
        <hr/>
      </div>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/PurchasePaymentGateway.js
 **/